export default "__VITE_ASSET__DuQoA6Sq__"